import React from 'react';
import { createRoot } from 'react-dom/client';
import { IntlProvider } from 'react-intl';
import GoogleTagManagerEvents from '../../config/GoogleTagManagerEvents';
import { BrowserRouter as Router } from 'react-router-dom';
import { Portal } from '../../aem-core-components';
import config from '../App/config';
import loadLocaleData, { locale, messages } from '../App/i18n';
import { initSentry } from '../global/utils/logger';
import { GuidedRegProvider } from '../guidedReg/context/guidedRegContext';
import GuidedRegHeader from '../guidedReg/header/GuidedRegHeader';
import GuidedReg from '../guidedReg/GuidedReg';
import CashFlow from '../guidedReg/cashFlow';
import ApplicationStatus from '../guidedReg/cashFlow/ApplicationStatus';
import ApplicationError from '../guidedReg/applicationError';

const App = props => {
    return (
        <IntlProvider locale={locale} messages={messages}>
            <GoogleTagManagerEvents>
                <GuidedRegProvider>
                    <Portal selector={config.mountingPoints.guidedRegWorkflow}>
                        <GuidedReg />
                    </Portal>
                    <Portal selector={config.mountingPoints.cashWorkflow}>
                        <CashFlow />
                    </Portal>
                    <Portal selector={config.mountingPoints.cashWorkflowApplicationStatus}>
                        <ApplicationStatus />
                    </Portal>
                    <Portal selector={config.mountingPoints.ccaWorkflowHeader}>
                        <GuidedRegHeader />
                    </Portal>
                    <Portal selector={config.mountingPoints.grApplicationError}>
                        <ApplicationError />
                    </Portal>
                </GuidedRegProvider>
            </GoogleTagManagerEvents>
        </IntlProvider>
    );
};

window.onload = async () => {
    const { locale, messages } = await loadLocaleData();
    const root = document.createElement('div');
    document.body.appendChild(root);
    const isDevelopment = process.env.NODE_ENV === 'development';
    if (!isDevelopment) {
        await initSentry();
    }
    const rootContainer = createRoot(root);
    rootContainer.render(
        <Router>
            <App locale={locale} messages={messages} />
        </Router>
    );
};

export default App;
